import React from 'react'

import Icon from '@/atoms/Icon'
import Button from '@/atoms/Button'

import { StyledFormSubmit, } from './styles'

const Submit = ({
  inline,
  submit,
  isValid,
  isSubmitting,
  errors
}) => {
  const isInvalid = !isValid || !!Object.entries(errors).length

  return (
    <StyledFormSubmit
      inline={inline}
    >
      <Button
        className="FormSubmit"
        disabled={isInvalid || isSubmitting}
        {...submit}
        rounded={inline}
      >
        {
          submit.icon &&
          <Icon name={submit.icon}/>
        }
      </Button>
    </StyledFormSubmit>
  )
}

export default Submit
